import styled from 'styled-components';

export default styled.div`
  width: 228px;
  padding: 3px 1px 1px 3px;
  border: 2px solid #000;
  
  p {
    width: 220px;
    height: 22px;
  }
`;
